(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-carrusel-movimiento"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarAcc(root) {
    var paneles = Array.prototype.slice.call(root.querySelectorAll('.pip-acc__panel'));
    if (!paneles.length) return;
    var esEscritorio = window.matchMedia('(min-width: 750px)');

    function activar(indice) {
      paneles.forEach(function (panel, i) {
        panel.classList.toggle('pip-acc__panel--activo', i === indice);
      });
    }

    paneles.forEach(function (panel, i) {
      panel.addEventListener('mouseenter', function () {
        if (esEscritorio.matches) activar(i);
      });
      panel.addEventListener('click', function (e) {
        if (esEscritorio.matches) {
          activar(i);
        } else {
          if (panel.classList.contains('pip-acc__panel--activo')) return;
          e.preventDefault();
          activar(i);
        }
      });
    });

    root.addEventListener('shopify:block:select', function (e) {
      var idx = e.target.getAttribute('data-indice');
      if (idx !== null) activar(parseInt(idx, 10));
    });
  }

  function iniciar() {
    document.querySelectorAll('.pip-acc').forEach(iniciarAcc);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-acc');
    if (el) iniciarAcc(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-beneficios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pip-tabs__tab'));
    var paneles = Array.prototype.slice.call(root.querySelectorAll('.pip-tabs__panel'));
    if (!tabs.length) return;

    function activar(indice) {
      tabs.forEach(function (tab) {
        var activo = tab.getAttribute('data-indice') === String(indice);
        tab.classList.toggle('pip-tabs__tab--activo', activo);
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
      });
      paneles.forEach(function (panel) {
        var activo = panel.getAttribute('data-indice') === String(indice);
        panel.classList.toggle('pip-tabs__panel--activo', activo);
        panel.hidden = !activo;
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activar(tab.getAttribute('data-indice'));
      });
      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab);
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var siguiente = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
          if (siguiente < 0) siguiente = tabs.length - 1;
          if (siguiente >= tabs.length) siguiente = 0;
          tabs[siguiente].focus();
          activar(tabs[siguiente].getAttribute('data-indice'));
        }
      });
    });

    root.addEventListener('shopify:block:select', function (e) {
      var idx = e.target.getAttribute('data-indice');
      if (idx !== null) activar(idx);
    });
  }

  function iniciar() {
    document.querySelectorAll('.pip-tabs').forEach(iniciarTabs);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-tabs');
    if (el) iniciarTabs(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-pack"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarPack(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__tab'));
    var paneles = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__panel'));
    var medios = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__media'));
    var botones = Array.prototype.slice.call(root.querySelectorAll('.pip-pack__boton'));
    if (!tabs.length) return;

    var total = tabs.length;
    var actual = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';

    function porIndice(lista, indice) {
      lista.forEach(function (el) {
        var activo = el.getAttribute('data-indice') === String(indice);
        el.hidden = !activo;
        el.classList.toggle('pip-pack__panel--activo', activo && el.classList.contains('pip-pack__panel'));
        el.classList.toggle('pip-pack__media--activo', activo && el.classList.contains('pip-pack__media'));
        el.classList.toggle('pip-pack__boton--activo', activo && el.classList.contains('pip-pack__boton'));
      });
    }

    function activar(indice) {
      actual = ((indice % total) + total) % total;
      tabs.forEach(function (tab) {
        var activo = tab.getAttribute('data-indice') === String(actual);
        tab.classList.remove('pip-pack__tab--activo');
        tab.setAttribute('aria-selected', activo ? 'true' : 'false');
        if (activo) {
          void tab.offsetWidth;
          tab.classList.add('pip-pack__tab--activo');
        }
      });
      porIndice(paneles, actual);
      porIndice(medios, actual);
      porIndice(botones, actual);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activar(parseInt(tab.getAttribute('data-indice'), 10));
      });
    });

    if (autoplay && total > 1) {
      tabs.forEach(function (tab) {
        var ring = tab.querySelector('.pip-pack__ring circle');
        if (ring) {
          ring.addEventListener('animationend', function () {
            if (tab.classList.contains('pip-pack__tab--activo')) {
              activar(actual + 1);
            }
          });
        }
      });

      if (root.classList.contains('pip-pack--pausable')) {
        root.addEventListener('mouseenter', function () { root.classList.add('pip-pack--pausado'); });
        root.addEventListener('mouseleave', function () { root.classList.remove('pip-pack--pausado'); });
      }
    }

    root.addEventListener('shopify:block:select', function (e) {
      var idx = e.target.getAttribute('data-indice');
      if (idx !== null) activar(parseInt(idx, 10));
    });

    activar(0);
  }

  function iniciar() {
    document.querySelectorAll('.pip-pack').forEach(iniciarPack);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-pack');
    if (el) iniciarPack(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-template-rows"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFaq(root) {
    var cerrarOtras = root.getAttribute('data-cerrar-otras') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('.pip-faq__item'));

    items.forEach(function (item) {
      var btn = item.querySelector('.pip-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('pip-faq__item--abierto');
        if (cerrarOtras) {
          items.forEach(function (otro) {
            otro.classList.remove('pip-faq__item--abierto');
            var b = otro.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (abierto) {
          item.classList.remove('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var toggle = root.querySelector('.pip-faq__toggle');
    if (toggle) {
      var extras = Array.prototype.slice.call(root.querySelectorAll('[data-extra="true"]'));
      var textoMas = toggle.getAttribute('data-mas');
      var textoMenos = toggle.getAttribute('data-menos');
      toggle.addEventListener('click', function () {
        var expandido = toggle.getAttribute('aria-expanded') === 'true';
        if (expandido) {
          extras.forEach(function (ex) {
            ex.classList.remove('pip-faq__item--abierto');
            var b = ex.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
            ex.hidden = true;
          });
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = textoMas;
        } else {
          extras.forEach(function (ex) { ex.hidden = false; });
          toggle.setAttribute('aria-expanded', 'true');
          toggle.textContent = textoMenos;
        }
      });
    }

    var video = root.querySelector('.pip-faq__video');
    var mediaBtn = root.querySelector('.pip-faq__media-btn');
    if (video && mediaBtn) {
      mediaBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          mediaBtn.setAttribute('data-estado', 'reproduciendo');
        } else {
          video.pause();
          mediaBtn.setAttribute('data-estado', 'pausado');
        }
      });
      video.addEventListener('play', function () { mediaBtn.setAttribute('data-estado', 'reproduciendo'); });
      video.addEventListener('pause', function () { mediaBtn.setAttribute('data-estado', 'pausado'); });
    }
  }

  function iniciar() {
    document.querySelectorAll('.pip-faq').forEach(iniciarFaq);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-faq');
    if (el) iniciarFaq(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-slider-colections"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pip-slider-16__slide'));
    if (!slides.length) return;
    var contPreviews = root.querySelector('.pip-slider-16__previews');
    var btnPrev = root.querySelector('[data-direccion="prev"]');
    var btnNext = root.querySelector('[data-direccion="next"]');
    var total = slides.length;
    var actual = 0;
    var cantidad = parseInt(root.getAttribute('data-previews') || '3', 10);
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var velocidad = parseInt(root.getAttribute('data-velocidad') || '5000', 10);
    var temporizador = null;
    var limpiarSaliente = null;

    function pintarPreviews() {
      if (!contPreviews) return;
      if (total <= 1) {
        contPreviews.innerHTML = '';
        return;
      }
      var html = '';
      for (var k = 1; k <= cantidad; k++) {
        var idx = (actual + k) % total;
        var imagen = slides[idx].getAttribute('data-imagen-card');
        var fondo = imagen ? "background-image:url('" + imagen + "');" : 'background-color:#e0e0e0;';
        html += '<button type="button" class="pip-slider-16__preview-card" data-ir="' + idx + '" style="' + fondo + '" aria-label="Ir a la diapositiva ' + (idx + 1) + '"></button>';
      }
      contPreviews.innerHTML = html;
    }

    function reiniciar() {
      if (!autoplay) return;
      clearInterval(temporizador);
      temporizador = setInterval(siguiente, velocidad);
    }

    function ir(i) {
      var nuevo = ((i % total) + total) % total;
      if (nuevo === actual) return;
      var previo = actual;
      actual = nuevo;

      slides.forEach(function (s, idx) {
        s.classList.remove('pip-slider-16__slide--activo', 'pip-slider-16__slide--saliente');
        if (idx === actual) {
          void s.offsetWidth;
          s.classList.add('pip-slider-16__slide--activo');
        } else if (idx === previo) {
          s.classList.add('pip-slider-16__slide--saliente');
        }
      });

      clearTimeout(limpiarSaliente);
      limpiarSaliente = setTimeout(function () {
        slides.forEach(function (s) {
          s.classList.remove('pip-slider-16__slide--saliente');
        });
      }, 900);

      pintarPreviews();
      reiniciar();
    }

    function siguiente() { ir(actual + 1); }
    function anterior() { ir(actual - 1); }

    if (btnNext) btnNext.addEventListener('click', siguiente);
    if (btnPrev) btnPrev.addEventListener('click', anterior);
    if (contPreviews) {
      contPreviews.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ir]');
        if (b) ir(parseInt(b.getAttribute('data-ir'), 10));
      });
    }

    pintarPreviews();
    reiniciar();
  }

  function iniciar() {
    document.querySelectorAll('.pip-slider-16').forEach(iniciarSlider);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-slider-16');
    if (el) iniciarSlider(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pip-testimonios-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function tvParse(url) {
      url = (url || '').trim();
      var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
      if (yt) return { type: 'youtube', id: yt[1] };
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vm) return { type: 'vimeo', id: vm[1] };
      if (/\.(mp4|webm|ogg|mov)(\?|$)/i.test(url)) return { type: 'file', src: url };
      return { type: 'iframe', src: url };
    }

    function tvPlay(media, root) {
      if (media.dataset.tvPlaying) return;
      root.querySelectorAll('[data-tv-media] video').forEach(function (v) { try { v.pause(); } catch (e) {} });

      var url = media.dataset.tvUrl;
      if (url) {
        var p = tvParse(url);
        var html = '';
        if (p.type === 'youtube') {
          html = '<iframe src="https://www.youtube.com/embed/' + p.id + '?autoplay=1&rel=0&playsinline=1" allow="autoplay; fullscreen; encrypted-media" allowfullscreen></iframe>';
        } else if (p.type === 'vimeo') {
          html = '<iframe src="https://player.vimeo.com/video/' + p.id + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        } else if (p.type === 'file') {
          html = '<video src="' + p.src + '" controls autoplay playsinline></video>';
        } else {
          html = '<iframe src="' + p.src + '" allow="autoplay; fullscreen" allowfullscreen></iframe>';
        }
        media.innerHTML = html;
        media.dataset.tvPlaying = '1';
        media.classList.add('tv-activo');
      } else {
        var v = media.querySelector('video');
        if (v) {
          v.setAttribute('controls', '');
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {});
          media.dataset.tvPlaying = '1';
          media.classList.add('tv-activo');
        }
      }
    }

    function initRoot(root) {
      if (root.dataset.tvInit) return;
      root.dataset.tvInit = '1';

      root.addEventListener('click', function (e) {
        var media = e.target.closest('[data-tv-media]');
        if (media && root.contains(media)) {
          if (!media.classList.contains('tv-activo')) tvPlay(media, root);
        }
      });

      var pista = root.querySelector('[data-tv-pista]');
      var prev = root.querySelector('[data-tv-arrow="prev"]');
      var next = root.querySelector('[data-tv-arrow="next"]');

      if (pista) {
        function step() {
          var card = pista.querySelector('[data-tv-tarjeta]');
          var gs = getComputedStyle(pista);
          var g = parseFloat(gs.columnGap || gs.gap || '0') || 0;
          return card ? card.offsetWidth + g : pista.clientWidth;
        }
        if (next) next.addEventListener('click', function () { pista.scrollBy({ left: step(), behavior: 'smooth' }); });
        if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -step(), behavior: 'smooth' }); });

        function updEdges() {
          if (!prev || !next) return;
          prev.classList.toggle('tv-off', pista.scrollLeft <= 2);
          next.classList.toggle('tv-off', pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2);
        }
        pista.addEventListener('scroll', updEdges);
        window.addEventListener('resize', updEdges);
        updEdges();
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-tv-root]').forEach(initRoot);
    }

    if (document.readyState !== 'loading') initAll();
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
